import React from 'react';
import { DeleteModal } from '../style';
import { Button } from '@design-system/Button';
import { delete_address } from '../redux/reducer';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

const DeleteAddress = ({ closeModal, id }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(delete_address(id));
  };
  return (
    <DeleteModal>
      <div className="delete__header">
        <p className="header_text-1">Delete Address?</p>
        <p className="header_text-2">
          Are you sure you want to delete this address? This action cannot be undone.
        </p>
      </div>
      <div className="action__button">
        <Button
          width="170px"
          text="Cancel"
          border="1px solid #E0E0E0"
          color="#4F4F4F"
          bgColor="#FFFFFF"
          weight="500"
          onClick={closeModal}
        />
        <Button
          width="170px"
          text="Delete"
          bgColor="#D92D20"
          weight="500"
          onClick={handleDelete}
        />
      </div>
    </DeleteModal>
  );
};

export default DeleteAddress;

DeleteAddress.propTypes = {
  closeModal: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};
